import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
	esp: (
		`
		<h4 class="mb-3 bold text-center">Fragmento el poemo «Kamparaj geknaboj»</h4>

		<div class="poem">
			<p class="poem-block mb-3">
				Jen foje, dum vintra malvarma vetero <br/>
				Mi iris promene tra densa arbar’ <br/>
				Kaj vidas, ke tiras ĉevalo mizera <br/>
				Ĉaregon, ŝarĝitan de seka branĉar’. 
			</p>

			<p class="poem-block mb-3">
				Elpaŝas solide, trankvila kaj grava, <br/>
				Tenante la bridojn, bizara kampul’: <br/>
				En botoj grandegaj, ŝafpelto, vid’ brava, <br/>
				La gantoj enormaj, sed mem ja etul’!
			</p>

			<p class="poem-block mb-3">
				-«Saluton, knabego!» – «Pluiru kun Dio!» <br/>
				-«Severa vi estas!» – (mi kun ironi’). <br/>
				-«De kie lignaĵ’?» – «El arbar’ gubernia: <br/>
				La patro hakadas, forportas do mi».
			</p>

			<p class="poem-block mb-3">
				(Proksime la son’ de hakilo aùdiĝas). <br/>
				-«Ĉu granda rezidas en hejm’ famili’?» <br/>
				-«Jes, granda, sed nure du viroj troviĝas <br/>
				En la patrodomo: la patro kaj mi» 
			</p>

			<p class="poem-block mb-3">
				-«Do jene! Kaj kiel vin nomi?» – «Mi – Vlaso» <br/>
				-«Kaj kiom vi aĝas?» – «Ĵus pasis sesjar’… <br/>
				Nu, pigra!» – ekkriis etulo per baso, <br/>
				La bridojn ektiris – kaj for el arbar’.
			</p>
		</div>
	`
	)
}

const itemName = {
	esp: 'Nikolaj Nekrasov'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;